enum FILTER_KEYS {
  LANGUANGE_FILTER = 'language-filter',
  CATEGORIES_FILTER = 'categories-filter',
  DISH_SIZE_FILTER = 'dish-size-filter',
  MENU_TYPE_FILTER = 'menu-type-filter',
  ALLERGENS_FILTER = 'allergens-filter'
}

enum TABLE_KEYS {
  DISHES = 'dishes',
  DISHES_SALSES_REPORT = 'dishes-sales-report',
  TOPPINGS = 'toppings',
  TOPPINGS_SALES_REPORT = 'toppings-sales-report',
  INGREDIENTS = 'ingredients',
  INGREDIENTS_SALES_REPORT = 'ingredients-sales-report',
  EMPLOYEES = 'employees',
  ITEMS_SOLD_UNIT = 'items-sold-unit',
  DEFAULT_KEY = 'default-key',
  QUANTITY_TABLE = 'quantity-table',
  DEVICES = 'devices',
  LOYALTY_REWARDS = 'loyalty-rewards'
}

export { FILTER_KEYS, TABLE_KEYS }
